export default __webpack_public_path__ + "static/media/faction-eu.0b7fa405.png";